import React from 'react'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'

function SectionTitle (props) {
  const { children } = props

  return (
    <h3 className={styles.sectionTitle}>{ children }</h3>
  )
}

SectionTitle.propTypes = {
  children: PropTypes.object,
}

export default SectionTitle
